<template>
	<div id="header" class="containner flex justify-between item-center">
		<!--  导航左侧  -->
		<div class="flex item-center">
			<img src="../assets/logo.png" style="height: 50px;" class="hand"/>
			<router-link to="/" class="nav router-link px-10 py-20 text-lg gray weight hand hover-red ml-10" :class="{'active':to=='/'}">首页</router-link>
			<router-link to="/filmlist" class="nav router-link px-10 py-20 text-lg gray weight hand hover-red ml-10" :class="{'active':to=='/film'}">电影</router-link>
			<router-link to="/cinemalist" class="nav router-link px-10 py-20 text-lg gray weight hand hover-red ml-10" :class="{'active':to=='/cinema'}">影院</router-link>
			<a href="./show-list.html" class="nav router-link px-10 py-20 text-lg gray weight hand hover-red ml-10" :class="{'active':to=='./show-list.html'}">演出</a>
			<a href="./rank-list.html" class="nav router-link px-10 py-20 text-lg gray weight hand hover-red ml-10" :class="{'active':to=='./rank-list.html'}">榜单</a>
			<a href="./hot-list.html" class="nav router-link px-10 py-20 text-lg gray weight hand hover-red ml-10" :class="{'active':to=='./hot-list.html'}">热点</a>
			<a href="./mall.html" class="nav router-link px-10 py-20 text-lg gray weight hand hover-red ml-10" :class="{'active':to=='./mall.html'}">商城</a>
		</div>
		<!--  /导航左侧  -->
		<!--  导航右侧  -->
		<div class="flex item-center">
			<input type="text" placeholder="找影视剧、影人、影院" class="navbar-search" v-model="routeQuery.searchContent"/>
			<button class="navbar-btn" @click="search_click()"> 搜 索 </button>
			<a href="" class="router-link px-5 text-sm gray hand hover-red ml-10">你好，请登录</a>
			<a href="" class="router-link px-5 text-sm red hand ml-10">免费注册</a>
		</div>
		<!--  /导航右侧  -->
	</div>
</template>

<script>
	export default {
		data(){
			return{
				routeQuery: {
					currentIndex: 1,
					pageSize: 10,
					searchContent: null
				}
			}
		},
		methods: {
			search_click(){
				if(this.routeQuery.searchContent != null && this.routeQuery.searchContent != ""){
					this.$router.push({
						path: '/search',
						query: this.routeQuery
					})
				}
				
			}
		},
		props: ['to']
	}
</script>

<style>
	.nav.active{background-color: #e1251b; color: #fff;}
	.navbar-search{outline: none; padding: 9px 19px; border: 1px solid #e1251b; border-radius: 6px 0px 0px 6px;}
	.navbar-btn{outline: none; padding: 9px 20px; border: 0px; background-color: #e1251b; border-radius: 0px 6px 6px 0px; color: #fff; cursor: pointer;}
	.navbar-btn:hover{background-color: #f1452b;}
</style>
